let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("1jsQH")).then(() => parcelRequire('fa8lP'));